.transport {
  min-height: 32px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 16px;
}

.gridContainer {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  height: 48px;
}

.transportItem {
  display: flex;
  justify-content: center;
}
